<script>
    export default {
        props: {
            showHeader: {
                type: Boolean,
                default: true
            },
            showFooter: {
                type: Boolean,
                default: true
            }
        }
    };
</script>

<script setup>

    // SignInPageTemplate
    // This template is for sign-in pages that use SignInPageHeader.vue and PageFooter.vue in /src/template/components

    // Components ----
    import SignInPageHeader from './components/SignInPageHeader';
    import PageFooter from './components/PageFooter';


</script>

<template>
    <SignInPageHeader v-if="showHeader" />
    <div class="sign-in-page-body">
        <slot></slot>
    </div>
    <PageFooter v-if="showFooter" />
</template>
